import React from 'react';
import { testimonials } from '../../data/content';
import { SectionLabel } from '../ui/SectionLabel';
import { Stars } from '../ui/Stars';
export function TestimonialsGrid() {
  return <section aria-labelledby="testimonios-title" className="w-full bg-ink-800" data-id="element-207" data-mp="3m4i44sehypx0">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-20" data-id="element-208" data-mp="3m6ksl8004azm">
        <div className="max-w-3xl" data-id="element-209" data-mp="3r2ryj0sedmhk">
          <SectionLabel data-id="element-210" data-mp="3r55vjf6n18rr">Elegido por padres que quieren acompañar con información</SectionLabel>
          <h2 id="testimonios-title" className="mt-5 font-display text-3xl font-black leading-tight text-white md:text-4xl" data-id="element-211" data-mp="2thxdju5uihui">
            Lo que dicen los padres
          </h2>
        </div>
        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-212" data-mp="38dcyn9og73er">
          {testimonials.map(item => <figure key={item.initials} className="flex h-full flex-col rounded-2xl border border-ink-border bg-ink-card p-6 shadow-panel transition-transform duration-150 ease-out hover:-translate-y-1" data-id="element-213" data-mp="ioay4f8m0gl2">
              <div className="flex items-center gap-3" data-id="element-214" data-mp="kbvzgbndetup">
                <span aria-hidden="true" className="flex h-11 w-11 items-center justify-center rounded-full text-sm font-black text-white" style={{
              backgroundColor: item.color
            }} data-id="element-215" data-mp="ffyji6g0rpig">
                  {item.initials}
                </span>
                <Stars data-id="element-216" data-mp="1fw6axinpk9j" />
              </div>
              <blockquote className="mt-4 flex-1 text-[15px] italic leading-relaxed text-body" data-id="element-217" data-mp="1gyxz7nszqqi">
                “{item.quote}”
              </blockquote>
              <figcaption className="mt-5 border-t border-ink-border pt-4" data-id="element-218" data-mp="3nvia0xpb2ttt">
                <span className="block text-sm font-bold text-white" data-id="element-219" data-mp="3jtn75orq88dx">{item.name}</span>
                <span className="block text-sm text-subtle" data-id="element-220" data-mp="3etr4ptyogp0h">{item.role}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}